import React from 'react';
import { translate } from '../Services/translation';
import CartIcon from '../../icons/cart.svg';

const MiniCart = ({ quantity, orderTotal, checkoutUrl, showInfo, toggle }) =>
    <div className="cart cart--mini">
        <a href={checkoutUrl} className="cart__link--block">
            <span className="cart__title">{translate('minicart.checkout')}</span>
            <span className="cart__icon-text--wrapper">
                <CartIcon className="icon" />
                {quantity > 0 && <span className="cart__quantity">{quantity}</span>}
            </span>

        </a>
    </div>


export default MiniCart;